const PHOTO_PROFILES = {
  Brighter: {
    name: 'Lysere',
    example: {
      url: '/assets/profiles/brighter-snap.png',
      thumb: '/assets/profiles/brighter-thumb-snap.png',
    },
    description: '',
  },
  Darker: {
    name: 'Mørkere',
    example: {
      url: '/assets/profiles/darker-snap.png',
      thumb: '/assets/profiles/darker-thumb-snap.png',
    },
    description: '',
  },
  'Colour Punch': {
    name: 'Fargepunch',
    example: {
      url: '/assets/profiles/colour_punch-snap.png',
      thumb: '/assets/profiles/colour_punch-thumb-snap.png',
    },
    description: '',
  },
  'Colour Punch Outdoor': {
    name: 'Fargepunch utebilder',
    example: {
      url: '/assets/profiles/colour_punch_outdoor-snap.png',
      thumb: '/assets/profiles/colour_punch_outdoor-thumb-snap.png',
    },
    description: '',
  },
  'Magazine': {
    name: 'Magasin',
    example: {
      url: '/assets/profiles/magazine-snap.png',
      thumb: '/assets/profiles/magazine-thumb-snap.png',
    },
    description: '',
  },
  'Retro': {
    name: 'Retro',
    example: {
      url: '/assets/profiles/retro-snap.png',
      thumb: '/assets/profiles/retro-thumb-snap.png',
    },
    description: '',
  },
  'Reduced Haze': {
    name: 'Reduser blass',
    example: {
      url: '/assets/profiles/reduced_haze-snap.png',
      thumb: '/assets/profiles/reduced_haze-thumb-snap.png',
    },
    description: '',
  },
  'EM1 Heimdal': {
    name: 'EM1 Heimdal',
    example: {
      url: '/assets/profiles/em1_heimdal-snap.png',
      thumb: '/assets/profiles/em1_heimdal-thumb-snap.png',
    },
    description: '',
  },
  'PM Rodeløkka': {
    name: 'PM Rodeløkka',
    example: {
      url: '/assets/profiles/pm_rodelokka-snap.png',
      thumb: '/assets/profiles/pm_rodelokka-thumb-snap.png',
    },
    description: '',
  },
  'Lettere': {
    name: 'Lettere',
    example: {
      url: '/assets/profiles/lettere-snap.png',
      thumb: '/assets/profiles/lettere-thumb-snap.png',
    },
    description: '',
  },
  'Marrakech': {
    name: 'Marrakech',
    example: {
      url: '/assets/profiles/marrakech-snap.png',
      thumb: '/assets/profiles/marrakech-thumb-snap.png',
    },
    description: '',
  },
  'Sahara': {
    name: 'Sahara',
    example: {
      url: '/assets/profiles/sahara-snap.png',
      thumb: '/assets/profiles/sahara-thumb-snap.png',
    },
    description: '',
  },
  'Stockholm': {
    name: 'Stockholm',
    example: {
      url: '/assets/profiles/stockholm-snap.png',
      thumb: '/assets/profiles/stockholm-thumb-snap.png',
    },
    description: '',
  },
  'Svalbard': {
    name: 'Svalbard',
    example: {
      url: '/assets/profiles/svalbard-snap.png',
      thumb: '/assets/profiles/svalbard-thumb-snap.png',
    },
    description: '',
  },
  'Tromsø': {
    name: 'Tromsø',
    example: {
      url: '/assets/profiles/tromso-snap.png',
      thumb: '/assets/profiles/tromso-thumb-snap.png',
    },
    description: '',
  },
  '': {
    name: 'Standard',
    example: {
      url: '/assets/profiles/standard.jpg',
      thumb: '/assets/profiles/standard-thumb.jpg',
    },
    description: ''
  },
}

export function getProfile(profile) {
  return PHOTO_PROFILES[profile] || {
    name: profile,
  }
}
